import { Injectable } from '@angular/core'
import { BehaviorSubject } from 'rxjs'

export enum BillingPageEnum {
  CardList = 'cardList',
  AddCard = 'addCard',
}

@Injectable({
  providedIn: 'root',
})
export class GbBillingViewService {
  public billingPageShowing$ = new BehaviorSubject<BillingPageEnum>(BillingPageEnum.CardList)
  public pageShowing$ = this.billingPageShowing$.asObservable()

  constructor() {}

  goToAddCard(): void {
    this.billingPageShowing$.next(BillingPageEnum.AddCard)
  }

  goToCardList(): void {
    this.billingPageShowing$.next(BillingPageEnum.CardList)
  }
}
